interface IDashboardMenus {
  title: string
  icon: string
  path?: string
  description?: string
  hidden?: boolean
  children?: IDashboardMenus[]
}

export const SIDEBAR_EXPAND_WIDTH = 280;
export const SIDEBAR_COLLAPSED_WIDTH = 72;
export const APP_MENU: Record<string, { name: string, routes: IDashboardMenus[] }> = {
  main: {
    name: '核心',
    routes: [
      {
        title: '仪表盘',
        icon: 'LayoutDashboard',
        path: '/dashboard/home',
      },
      {
        title: '任务栏',
        icon: 'ClipboardCheck',
        path: '/dashboard/task',
        description: 'Manage Tasks'
      },
      {
        title: '数据分析',
        icon: 'BarChart3',
        path: '/dashboard/analytics',
        description: '运营数据统计'
      },
      {
        path: '/dashboard/mailbox',
        title: '我的邮箱',
        icon: 'Mail',
        description: '收发邮件'
      },
    ],
  },
  settings: {
    name: '通用',
    routes: [
      {
        title: '用户管理',
        icon: 'Users',
        description: 'Manage Users',
        children: [
          {
            path: '/dashboard/visit',
            title: '访客列表',
            icon: 'Users',
            description: 'Manage Visit'
          },
          {
            path: '/dashboard/leads',
            title: '客户列表',
            icon: 'Contact',
            description: 'Manage Leads'
          },
          {
            path: '/dashboard/sample-record',
            title: '样品记录',
            icon: 'Package',
            description: 'Manage Sample Records'
          },
        ]
      },
      {
        title: '模板管理',
        icon: 'FileText',
        description: 'Manage Templates',
        children: [
          // {
          //   path: '/dashboard/doc-template-categories',
          //   title: '文档模板分类',
          //   icon: 'FolderTree',
          //   description: 'Manage Template Categories'
          // },
          // {
          //   path: '/dashboard/doc-templates',
          //   title: '文档管理',
          //   icon: 'FileSpreadsheet',
          //   description: 'Manage Templates'
          // },
          {
            path: '/dashboard/email',
            title: '邮件模板',
            icon: 'Mail',
            description: 'Manage Email Templates'
          },
          {
            path: '/dashboard/sendgrid',
            title: 'WorkMail发送测试',
            icon: 'Mail',
            description: 'Send Email via WorkMail'
          },

        ]
      },    
      {
        title: '产品管理',
        icon: 'Package',
        children: [
          {
            path: '/dashboard/category',
            title: '产品分类',
            icon: 'Tags',
            description: 'Manage Category'
          },
          {
            path: '/dashboard/product-part-number',
            title: '料号配置管理',
            icon: 'Hash',
            description: 'Manage Product Part Numbers'
          },
          {
            path: '/dashboard/spec-type',
            title: '技术参数类型',
            icon: 'Settings',
            description: 'Manage Spec Types'
          },
          {
            path: '/dashboard/product',
            title: '产品列表',
            icon: 'Package',
            description: 'Manage Product'
          },
          {
            path: '/dashboard/featured-product',
            title: '主推产品',
            icon: 'Star',
            description: 'Manage Featured Products'
          },
        ]
      },
      {
        path: '/dashboard/order',
        title: '订单管理',
        icon: 'ShoppingCart',
        description: 'Manage Orders'
      },
      {
        path: '/dashboard/news',
        title: '文章管理',
        icon: 'Newspaper',
        description: 'Manage News'
      },
      {
        title: '企业管理',
        icon: 'Building2',
        description: 'Manage Department',
        children: [
          {
            path: '/dashboard/department',
            title: '部门管理',
            icon: 'Building2',
            description: 'Manage Department'
          },
          {
            path: '/dashboard/employee',
            title: '员工管理',
            icon: 'UserCheck',
            description: 'Manage Employee'
          },
          {
            path: '/dashboard/payment-account',
            title: '收款账号管理',
            icon: 'CreditCard',
            description: 'Manage Payment Accounts'
          },
          {
            path: '/dashboard/workmail',
            title: 'WorkMail 账户管理',
            icon: 'Mail',
            description: 'Manage WorkMail Accounts'
          },
        ]
      },
      {
        title: '页面设置',
        icon: 'FileText',
        description: 'Page Settings',
        // 移除父菜单的 path，避免与子菜单 path 冲突
        // 父菜单点击时通过 SidebarInner.vue 中的逻辑导航到第一个子菜单
        children: [
          {
            path: '/dashboard/page-content/home-about',
            title: '首页 About Us',
            icon: 'Home',
            description: 'Home About Us Section'
          },
          {
            path: '/dashboard/page-content/factory',
            title: '工厂页面',
            icon: 'Factory',
            description: 'Factory Page Settings'
          },
          {
            path: '/dashboard/page-content/company',
            title: '公司页面',
            icon: 'Building2',
            description: 'Company Page Settings'
          },
          {
            path: '/dashboard/page-content/quality',
            title: '质量页面',
            icon: 'Award',
            description: 'Quality Page Settings'
          },
          {
            path: '/dashboard/page-content/privacy',
            title: '隐私政策',
            icon: 'Shield',
            description: 'Privacy Policy Settings'
          },
          {
            path: '/dashboard/page-content/resources',
            title: 'Resources 页面',
            icon: 'Newspaper',
            description: 'Resources / News Banner Settings'
          },
        ]
      },
      {
        title: '通用设置',
        icon: 'Settings2',
        description: 'Settings',
        children: [
          {
            path: '/dashboard/resource',
            title: '资源管理',
            icon: 'FolderTree',
            description: 'Manage Resources'
          },
          {
            path: '/dashboard/pages',
            title: '页面管理',
            icon: 'FileText',
            description: 'Manage Pages'
          },
          {
            path: '/dashboard/banner',
            title: 'Banner管理',
            icon: 'Image',
            description: 'Manage Banners'
          },
          // {
          //   path: '/dashboard/language',
          //   title: '语言管理',
          //   icon: 'Globe',
          //   description: 'Manage Languages'
          // },
         
          {
            path: '/dashboard/settings',
            title: '系统设置',
            icon: 'Settings2',
            description: 'Settings'
          },
          {
            path: '/dashboard/menu',
            title: '菜单管理',
            icon: 'Menu',
            description: 'Manage Menus'
          },
        ]
      }
    ],
  },
};

export const globalSearch = {

};
